<template>
  <CommonOverlay
    class="overlay"
    v-show="showLoginPage"
    @handleOverlayClick="closeLoginModal"
  >
    <CommonModal class="modal" @click.native.stop>
      <TabMenu  :tabs="tabs" :activeTab="mode" @update-activeTab="changeMethod" />
        <Login v-if="mode === 1" />
        <MemberSave v-if="mode === 2" />
    </CommonModal>
  </CommonOverlay>
</template>

<script>
import { mapGetters } from 'vuex';
import t from '@/plugins/i18n';
import CommonOverlay from '@/components/atoms/CommonOverlay.vue';
import CommonModal from '@/components/atoms/CommonModal.vue';
import TabMenu from '@/components/molecules/TabMenu.vue';
import Login from '@/components/organisms/Login/Login.vue';
import MemberSave from '@/components/organisms/Login/MemberSave.vue';

export default {
  name: 'LoginPopup',
  mixins: [t],

  components: {
    CommonOverlay,
    CommonModal,
    TabMenu,
    Login,
    MemberSave,
  },

  data: () => ({
    mode: 1,
    showPassword: false,
  }),

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
      showLoginPage: 'user/showLoginPage',
    }),
    tabs() {
      return [
        { id: 1, label: this.t('ログイン') },
        { id: 2, label: this.t('会員登録') },
      ];
    },
  },

  methods: {
    closeLoginModal() {
      this.$store.dispatch('user/setShowLoginPage', false);
    },
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
    changeMethod(id) {
      this.mode = id;
    },
  },
};

</script>

<style lang="scss" scoped>
.overlay {
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  .modal {
    width: auto;
    padding: 20px;
    width: 600px;
    max-height: 600px;
    overflow-y: auto;
  }
}
@media screen and  (max-width: $tabletWidth) {
  .overlay {
    .modal {
      width: 95%;
      height: 80%;
    }
  }
}
</style>
